import { HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs/internal/Observable';

import { EnvironmentConfig, IConfiguration } from '../../../../client-config/bma-env-config';
import { CustomHttpClientService } from '../../../../core/custom-http-client.service';

@Injectable({
    providedIn: 'root',
})
export class UserPreferenceProvider {
    UPMS: string | undefined;
    private readonly environment: IConfiguration = inject(EnvironmentConfig).configuration;
    brand: string | undefined = this.environment.BRAND;
    private customHttpClientService = inject(CustomHttpClientService);
    constructor() {
        this.UPMS = this.environment.UPMS;
    }
    getOddsPreference(token: any): Observable<any> {
        const headers = new HttpHeaders({
            token: token,
        });
        return this.customHttpClientService.httpClient.get(`${this.UPMS}/${this.brand}`, { headers });
    }
    setOddsPreference(pref: any, token: any): Observable<any> {
        pref.brand = this.brand;
        return this.customHttpClientService.httpClient.put<number[]>(`${this.UPMS}`, pref, {
            headers: { token },
        });
    }
}
